export const MATCHNOTE = {
    title: "Matchnote",
    liveUrl: null as string | null,
    repositoryUrl: null as string | null,
    video: `${process.env.PUBLIC_URL}/videos/matchnote-invoice-desk-30s-1080p.mp4`,
    poster: `${process.env.PUBLIC_URL}/videos/matchnote-poster.jpg`,
    captions: `${process.env.PUBLIC_URL}/videos/matchnote-en.vtt`,
};
